import { useQuery } from 'react-query';
import { ScorecardTemplateService } from '../../../services/v1/applicant_tracking/ScorecardTemplateService';

export const useScorecardTemplates = (id: number, expand?: string[]) =>
  useQuery({
    queryKey: ['scorecard_templates', { expand: expand }],
    queryFn: () => ScorecardTemplateService.show(id.toString(), { expand }),
  });
